import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Section, SectionNumberingProvider, TemplateDocument, TemplateFooter, TemplateLetterhead, } from '../../../atoms/index.js';
import { SAMTYCKE_DESCRIPTION, SAMTYCKE_TEXT, SHARED_SAMPLE_VALUES, SHARED_SECTION_DEFS, SamtyckeSharedBody, buildSharedFields, } from '../shared.js';
export const metadata = {
    sections: [...SHARED_SECTION_DEFS, { ref: 'samtycke', title: 'Samtycke' }],
    templateKey: 'samtycke_sarskilda_bilaga',
    version: 'v1',
    category: 'Övriga avtal',
    title: 'Samtycke till behandling av särskilda kategorier av personuppgifter · Version 2026',
    shortTitle: 'Samtycke särskilda kategorier (bilaga)',
    formNumber: 'Formulär R-23',
    preamble: 'Hyresgästens samtycke till behandling av särskilda kategorier av personuppgifter (GDPR artikel 9).',
    description: SAMTYCKE_DESCRIPTION +
        '\n\nSkapas som bilaga under ett bostads- eller studentbostadsavtal — visas inte i avtalslistan, har ingen egen signering. Parter och avtalsnummer hämtas från avtalet. Bifogas det signerade avtalet automatiskt vid utskick via Scrive.\n\n' +
        'Behöver dokumentet signeras separat (utan ett kopplat hyresavtal) — använd den fristående mallen "Samtycke särskilda kategorier" under Övriga avtal.',
    status: 'active',
    attachableTo: ['bostadshyra', 'studentbostad'],
    singletonPerParent: true,
    partySlots: [],
};
export const variableSchema = buildSharedFields('bilaga');
export const sampleValues = SHARED_SAMPLE_VALUES;
export function Letterhead() {
    return (_jsx(TemplateLetterhead, { title: metadata.title, formNumber: metadata.formNumber }));
}
export function PageFooter() {
    return _jsx(TemplateFooter, { formNumber: metadata.formNumber });
}
export function Body(props) {
    const { values, mode } = props;
    return (_jsxs(SectionNumberingProvider, { sections: metadata.sections ?? [], values: values, mode: mode, children: [_jsx("p", { className: "mb-4 italic text-stone-600", children: metadata.preamble }), _jsx(SamtyckeSharedBody, { ...props }), _jsxs(Section, { sectionRef: "samtycke", title: "Samtycke", children: [_jsx("p", { className: "text-[10.5px] leading-relaxed text-stone-700", children: SAMTYCKE_TEXT }), _jsx("p", { className: "mt-4 text-[10px] italic leading-relaxed text-stone-600", children: "Denna bilaga utg\u00F6r en del av hyresavtalet och undertecknas elektroniskt tillsammans med det. Egen underskrift kr\u00E4vs inte p\u00E5 denna handling." })] })] }));
}
export function Component(props) {
    return (_jsx(TemplateDocument, { header: _jsx(Letterhead, {}), footer: _jsx(PageFooter, {}), children: _jsx(Body, { ...props }) }));
}
//# sourceMappingURL=index.js.map